import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { currentVersion, platform } from 'utils'
import Tip from 'components/Tip'

/**
 * Encapsulates the use of a selector so the parent doesn't need to re-render just because of a single footer value.
 * @see FooterMsg
 * @param selector {function} If nothing is returned, no message will be shown
 * @param formatter {function} If given, will further process the value taken from the selector function
 * @param prefix {string}
 */
export function FooterState({ selector, formatter = null, prefix = '' }) {
	let value = useSelector(selector)
	if (formatter) {
		value = formatter(value)
	}
	return <FooterMsg prefix={prefix}>{value}</FooterMsg>
}

FooterState.propTypes = {
	selector : PropTypes.func.isRequired,
	prefix   : PropTypes.string,
	formatter: PropTypes.func,
}

/**
 * Simple style for a de-emphasized footer message. Shows nothing if there's no children.
 * @param children {string|JSX.Element}
 * @param className {string}
 * @param prefix {string}
 */
export function FooterMsg({ children, className = '', prefix = '' }) {
	return !children? null : <footer className={`footer-msg ${className}`}>{prefix} {children}</footer>
}

FooterMsg.propTypes = {
	prefix: PropTypes.string,
}

export function FooterVersion() {
	const { t }   = useTranslation()
	const version = currentVersion()
	const cordova = currentVersion(true)
	const host    = platform.isStg()? <> (<tt>{platform.hostname()}</tt>)</> : null
	return <FooterMsg prefix={t('Current version:')}>
		{version}
		{' '}
		{cordova && `(nat-${cordova})`}
		{' '}
		{!platform.isProd() && /* eslint-disable i18next/no-literal-string */
			<Tip text={<span>This is running from a <b>{platform.env()}</b> server{host}.</span>}>
				<big>🛠</big>{/* for some reason, the emoji needs a wrapper... then, we might as well make it bigger :) */}
			</Tip>}
	</FooterMsg>
}
